// Operations of the public applicant status flow. They authenticate by OTP
// session token / tracking code / school slug — never by the logged-in user —
// and must work with no token present.
//
// They must ALSO work with a token present: the SPA shares one browser with
// the staff/student portals, and sending a logged-in identity on these drags
// that login's school context into the backend's tenant scoping — a fresh OTP
// then reads "Invalid or expired verification code". EnsureSchoolContext
// skips identity for exactly this list server-side; keeping the headers off
// here makes the flow independent of which side deploys first.
export const APPLICANT_PUBLIC_OPERATIONS: ReadonlySet<string> = new Set([
  'ApplicantStatus',
  'RequestApplicantOtp',
  'VerifyApplicantOtp',
  'ApplicantSubmissions',
  'ApplicantReply',
  'ApplicantUploadFile',
  'ApplicantUpdateField',
]);

export const isApplicantPublicOperation = (operationName?: string | null): boolean =>
  !!operationName && APPLICANT_PUBLIC_OPERATIONS.has(operationName);
